module.exports = __webpack_public_path__ + "static/media/car2.96490447.png";